module.exports = __webpack_public_path__ + "media/images/sp/components/search/accordion/plus-b89e571ea8fab5a05524323ded1e006a.svg";